import { UPDATE_RESUMED_DATA } from '../constants/actionTypes'

export default (state = 0, action) => {
    switch (action.type) {
        case UPDATE_RESUMED_DATA:
            return action.payload
        default:
            return state
    }
}
